// Resolves the correct backend URL at runtime.
//
// Why this exists: REACT_APP_BACKEND_URL is baked into the frontend bundle at
// build time. In a deployment with a *custom domain* (e.g., the page is served
// from auxcast.auxscribe.com but the build env still points at the
// emergent.host URL), calling the build-time URL becomes a cross-origin
// request and the session cookie ends up first-party to the WRONG host. The
// browser then drops the cookie on subsequent same-origin requests and the
// user appears perpetually logged out.
//
// Resolution rule:
//   - In the browser, if the build-time REACT_APP_BACKEND_URL has a DIFFERENT
//     origin than the current page origin, ignore it and use the page's own
//     origin. The Kubernetes ingress routes `/api/*` to the backend pod for
//     every host that serves the frontend, so same-origin always works.
//   - Otherwise, prefer the build-time value (for non-browser / SSR / test
//     contexts).

const BUILD_TIME_URL = process.env.REACT_APP_BACKEND_URL || '';

export const getBackendUrl = () => {
  if (typeof window === 'undefined') return BUILD_TIME_URL;
  try {
    const pageOrigin = window.location.origin;
    if (!BUILD_TIME_URL) return pageOrigin;
    const buildOrigin = new URL(BUILD_TIME_URL).origin;
    return buildOrigin === pageOrigin ? BUILD_TIME_URL : pageOrigin;
  } catch (e) {
    return window.location.origin;
  }
};

export const getApiBase = () => `${getBackendUrl()}/api`;
